import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { DateInput, SelectGeneric, Button } from 'ypf-pas-general-ui-components';
import { Col } from 'react-bootstrap';

import { checkRol } from '../../../../security';
import { proveedorNotificador, proveedorAdministrador } from '../../../../security/constantsRols';
import useLoadServices from '../../../../hooks/useLoadServices';
import { useFilterContext } from '../../../../context/FilterContext';
import { ubicationTypeEnum } from '../../../../utils/dataStatus';
// eslint-disable-next-line import/order
import PositionLineFilter from '../../../../components/WeeklyReportTable/components/WeeklyReportFilters/PositionLineFilter/PositionLineFilter';
import './ContentFilter.scss';

import {
  fetchAprooverContracts,
  fetchProvidersForAproover
} from '../../../../components/WeeklyReportTable/utils/customFetchFunctions';

import {
  fetchDataUbication,
  fetchDataContratos,
  fetchDataProveedores,
  fetchDataServicios,
  fetchDataUsuarios,
  fetchDataTeam,
  fetchRequestsService,
  fetchDataUbicationByUbicationType,
  fetchEquipamentTower
} from './helpers/filtersFetcher';

const optionsState = [
  { id: 4, nombre: 'En ejecución' },
  { id: 5, nombre: 'Finalizada' }
];

const checkIsOyM = (tipoUbicacionEnum) =>
  tipoUbicacionEnum?.id !== ubicationTypeEnum.locacion &&
  tipoUbicacionEnum?.id !== ubicationTypeEnum.pozo;

const getSetValue = (isOyM, values) =>
  isOyM ? values?.operacionesIds : values?.unidadesNegocioIds;

const getSetFieldName = (isOyM) => (isOyM ? 'operacionesIds' : 'unidadesNegocioIds');

const ContentFilter = () => {
  const { formikFilters, handleClearFilters, handleSaveFilters } = useFilterContext();

  const location = useLocation();
  const gridRoute = location.pathname === '/';
  const approverRoute = location.pathname === '/approver';

  const {
    ubicationTypeSelect,
    statusSelect,
    prioritySelect,
    eventTypeSelect,
    businessUnitSelect,
    eventsSelect
  } = useLoadServices({ createSDS: true, ignoreInitLoad: approverRoute });

  const { values, handleChange, setFieldValue } = formikFilters;

  const isOyM = checkIsOyM(values.tipoUbicacionEnum);
  const setValue = getSetValue(isOyM, values);
  const setFieldName = getSetFieldName(isOyM);

  const handleSetFieldValues = (newValues) =>
    isOyM
      ? setFieldValue('operacionesIds', newValues || [])
      : setFieldValue('unidadesNegocioIds', newValues || []);

  const refPositionLineFilter = useRef();

  const onSaveFilter = () => {
    setFieldValue('posicionesLineas', refPositionLineFilter?.current?.positionLine);
    handleSaveFilters({
      posicionesLineas: refPositionLineFilter?.current?.positionLine
    });
  };

  const onChangeLocationType = (newValues) => {
    setFieldValue('tipoUbicacionEnum', newValues || null);
    setFieldValue('operacionesIds', []);
    setFieldValue('unidadesNegocioIds', []);
    setFieldValue('ubicacion', []);
    if (checkIsOyM(newValues)) {
      setFieldValue('equipo', []);
    }
  };

  return (
    <>
      {gridRoute ? (
        <div className="d-flex justify-content-between gap-2">
          <DateInput
            label="Fecha Desde"
            max={values?.fechaHasta}
            name="fechaDesde"
            onChange={handleChange}
            onClear={() => setFieldValue('fechaDesde', '')}
            placeholder="Desde"
            value={values?.fechaDesde}
          />
          <DateInput
            label="Fecha Hasta"
            min={values?.fechaDesde}
            name="fechaHasta"
            onChange={handleChange}
            onClear={() => setFieldValue('fechaHasta', '')}
            placeholder="Hasta"
            value={values?.fechaHasta}
          />
        </div>
      ) : null}
      {(checkRol(proveedorNotificador) || checkRol(proveedorAdministrador)) && gridRoute ? null : (
        <SelectGeneric
          async
          defaultValueOneOption={false}
          fetchData={(value) =>
            approverRoute
              ? fetchProvidersForAproover(value, values?.idsContratos)
              : fetchDataProveedores(value)
          }
          isMulti
          label="Proveedores"
          name="idsProveedores"
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={(newValues) => setFieldValue('idsProveedores', newValues || [])}
          paddingIndicator={4}
          placeholder="Buscar por nombre"
          value={values?.idsProveedores}
          withSelect="100%"
        />
      )}
      {gridRoute || approverRoute ? (
        <SelectGeneric
          async
          clearable
          fetchData={(value) =>
            approverRoute
              ? fetchAprooverContracts(value, values?.idsProveedores)
              : fetchDataContratos(value)
          }
          isMulti
          label="Contratos"
          name="idsContratos"
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={(newValue) => {
            refPositionLineFilter?.current?.resetFiltersOnChanges(newValue);
            setFieldValue('idsContratos', newValue);
          }}
          paddingIndicator={4}
          placeholder="Selecciona contrato"
          value={values?.idsContratos}
          withSelect="100%"
        />
      ) : null}

      {approverRoute && (
        <PositionLineFilter
          contratosIds={values?.idsContratos}
          formData={values}
          onChangePositonLine={() => {
            setFieldValue('posicionesLineasChanges', refPositionLineFilter?.current?.positionLine);
          }}
          ref={refPositionLineFilter}
        />
      )}

      <SelectGeneric
        async
        clearable
        fetchData={(value) => fetchRequestsService(value, approverRoute)}
        isMulti
        label="Solicitud de Servicio"
        name="numeroSolicitud"
        noOptionsMessage="Ingresar al menos 4 caracteres"
        onChange={(newValues) => {
          setFieldValue('numeroSolicitud', newValues);
        }}
        placeholder="Selecciona solicitud de servicio"
        value={values?.numeroSolicitud}
        withSelect="100%"
      />

      {gridRoute ? (
        <div>
          <SelectGeneric
            clearable
            isMulti
            label="Evento"
            name="idEvento"
            onChange={(newValue) => {
              setFieldValue('idEvento', newValue || []);
            }}
            options={eventTypeSelect}
            placeholder="Buscá por nombre"
            value={values?.idEvento}
            withSelect="100%"
          />
        </div>
      ) : null}
      <SelectGeneric
        clearable
        isDisabled={!ubicationTypeSelect}
        label="Tipo de ubicación"
        name="tipoUbicacionEnum"
        onChange={onChangeLocationType}
        options={ubicationTypeSelect}
        paddingIndicator={4}
        placeholder="Seleccione tipo de ubicación"
        value={values?.tipoUbicacionEnum}
        withSelect="100%"
      />
      <SelectGeneric
        clearable
        defaultValueOneOption={false}
        isDisabled={!setValue || !values?.tipoUbicacionEnum}
        isMulti
        label="Unidad de Negocio"
        name={setFieldName}
        onChange={(newValues) => {
          handleSetFieldValues(newValues);
        }}
        options={businessUnitSelect}
        paddingIndicator={4}
        placeholder="Seleccione una opción"
        value={setValue}
        withSelect="100%"
      />
      <SelectGeneric
        async
        clearable
        fetchData={(value) =>
          gridRoute || approverRoute
            ? fetchDataUbicationByUbicationType({
                value,
                typeUbication: values.tipoUbicacionEnum.id
              })
            : fetchDataUbication(value)
        }
        isDisabled={!values?.tipoUbicacionEnum && (gridRoute || approverRoute)}
        isMulti
        label="Ubicación"
        name="ubicacion"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValues) => {
          setFieldValue('ubicacion', newValues || null);
        }}
        paddingIndicator={4}
        placeholder="Buscar por nombre"
        value={values?.ubicacion && values.ubicacion}
        withSelect="100%"
      />

      {gridRoute ? (
        <SelectGeneric
          async
          fetchData={(value) =>
            fetchEquipamentTower({
              value,
              typeUbication: values.tipoUbicacionEnum.id
            })
          }
          isDisabled={!values.tipoUbicacionEnum}
          isMulti
          label="Equipo de torre"
          name="equipo"
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={(newValues) => {
            setFieldValue('equipo', newValues);
          }}
          placeholder="Seleccione equipo"
          value={values?.equipo}
          withSelect="100%"
        />
      ) : null}
      <SelectGeneric
        async
        defaultValueOneOption={false}
        fetchData={(value) => fetchDataServicios(value)}
        isMulti
        label="Servicio"
        name="idsServicios"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValues) => setFieldValue('idsServicios', newValues || null)}
        paddingIndicator={4}
        placeholder="Buscar por servicio"
        value={values?.idsServicios}
        withSelect="100%"
      />
      {approverRoute ? (
        <>
          <SelectGeneric
            clearable
            defaultValueOneOption={false}
            isDisabled={!eventsSelect}
            isMulti
            label="Tipo de evento"
            name="evento"
            onChange={(newValues) => {
              setFieldValue('evento', newValues || []);
            }}
            options={eventTypeSelect}
            paddingIndicator={4}
            placeholder="Seleccione tipo de evento"
            value={values?.evento}
            withSelect="100%"
          />
          <SelectGeneric
            async
            fetchData={(value) => fetchDataTeam(value)}
            isDisabled={!values?.tipoUbicacionEnum || isOyM}
            isMulti
            label="Equipo de torre"
            name="equipo"
            noOptionsMessage="Ingresar al menos 3 caracteres"
            onChange={(newValues) => {
              setFieldValue('equipo', newValues || []);
            }}
            paddingIndicator={4}
            placeholder="Seleccione equipo"
            value={values?.equipo}
            withSelect="100%"
          />
        </>
      ) : null}
      {approverRoute && !values?.isPending && (
        <Col sm={12}>
          <SelectGeneric
            clearable
            defaultValueOneOption={false}
            isMulti
            label="Estado de solicitud"
            name="estadosSolicitud"
            onChange={(newValue) => setFieldValue('estadosSolicitud', newValue)}
            options={optionsState}
            placeholder="Seleccionar estado de solicitud"
            type="text"
            value={values.estadosSolicitud}
            withSelect="100%"
          />
        </Col>
      )}
      {!gridRoute && !approverRoute ? (
        <SelectGeneric
          async
          fetchData={(value) => fetchDataContratos(value)}
          isMulti
          label="Contratos"
          name="idsContratos"
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={(newValue) => setFieldValue('idsContratos', newValue)}
          paddingIndicator={4}
          placeholder="Buscar por número"
          value={values?.idsContratos}
          withSelect="100%"
        />
      ) : null}
      {gridRoute && (
        <>
          <SelectGeneric
            className="select-status"
            clearable
            isDisabled={!statusSelect}
            isMulti
            label="Estado"
            name="estadosEnums"
            onChange={(newValues) => {
              setFieldValue('estadosEnums', newValues || []);
            }}
            options={statusSelect}
            placeholder="Seleccione estado"
            value={values?.estadosEnums}
            withSelect="100%"
          />
          <SelectGeneric
            async
            clearable
            fetchData={(value) => fetchDataUsuarios(value)}
            label="Usuario creador"
            name="idUsuarioCreador"
            noOptionsMessage="Ingresar al menos 3 caracteres"
            onChange={(newValue) => setFieldValue('idUsuarioCreador', newValue)}
            placeholder="Buscar por nombre"
            value={values?.idUsuarioCreador}
            withSelect="100%"
          />
          <SelectGeneric
            clearable
            isDisabled={!statusSelect}
            label="Prioridad"
            name="idPrioridad"
            onChange={(newValues) => setFieldValue('idPrioridad', newValues)}
            options={prioritySelect}
            placeholder="Seleccione prioridad"
            value={values?.idPrioridad}
            withSelect="100%"
          />
        </>
      )}
      <div className="container-buttons">
        <Button
          label="Limpiar"
          onClick={handleClearFilters}
          type="button"
          variant="outline-primary"
        />
        <Button label="Guardar" onClick={onSaveFilter} type="button" variant="outline-primary" />
        <Button label="Buscar" type="submit" variant="primary" />
      </div>
    </>
  );
};

export default ContentFilter;
